import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-conversation",
  "use": "icon-conversation-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-conversation\"><path d=\"M0 64.158291C0 28.724645 28.456375 0 64.055786 0L959.944211 0C995.321248 0 1024 29.168701 1024 64.158291L1024 703.841709C1024 739.275354 995.543622 768 959.944211 768L64.055786 768C28.678752 768 0 738.831296 0 703.841709L0 64.158291ZM256 768 512 768 256 1024 256 768ZM256 448C291.346224 448 320 419.346224 320 384 320 348.653776 291.346224 320 256 320 220.653776 320 192 348.653776 192 384 192 419.346224 220.653776 448 256 448ZM512 448C547.346224 448 576 419.346224 576 384 576 348.653776 547.346224 320 512 320 476.653776 320 448 348.653776 448 384 448 419.346224 476.653776 448 512 448ZM768 448C803.346221 448 832 419.346224 832 384 832 348.653776 803.346221 320 768 320 732.653779 320 704 348.653776 704 384 704 419.346224 732.653779 448 768 448Z\" p-id=\"1966\" fill=\"#2c2c2c\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/conversation.svg
// module id = rce0
// module chunks = 1